import { render, staticRenderFns } from "./PrivateMessageIcon.vue?vue&type=template&id=61c23060"
import script from "./PrivateMessageIcon.vue?vue&type=script&lang=js"
export * from "./PrivateMessageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports